export default {
   state: {
      title: "",
      message: "",
      isError: false,
      showDialog: false,
      returnLink: null,
      confirmAlert: {
         remindValue: {},
      }
   },
   getters: {
      confirmAlert: state => state.confirmAlert,
   },
   actions: {
      showAlert: ({ commit }, { title, message, isError, returnLink }) => {
         const obj = {
            title: "",
            message: "",
            isError: false,
            returnLink: returnLink || null,
         }

         switch (message) {
            case 'noData':
               obj['title'] = 'message.dataNotFound';
               obj['message'] = 'message.dataNotFoundMsg';
               obj['isError'] = true;
               break;
            case 'noPermission':
               obj['title'] = 'message.noPermission';
               obj['message'] = 'message.noPermission';
               obj['isError'] = true;
               break;
            default:
               obj['title'] = title;
               obj['message'] = message;
               obj['isError'] = isError;
               break;
         }
         commit('showAlert', obj);
      },
      closeAlert: ({ commit }) => {
         commit('closeAlert');
      },
      setConfirmAlertRemind: ({ commit }, { key, disable }) => {
         commit('setConfirmAlertRemind', { key, disable });
      },
      clearConfirmAlertRemind: ({ commit }) => {
         commit('clearConfirmAlertRemind');
      },
   },
   mutations: {
      showAlert: (state, { title, message, isError, returnLink }) => {
         state.showDialog = true;
         state.title = title;
         state.message = message;
         state.isError = isError;
         state.returnLink = returnLink;
      },
      closeAlert: (state) => {
         state.showDialog = false;
      },
      setConfirmAlertRemind: (state, value) => {
         state.confirmAlert.remindValue[value.key] = value.disable;
      },
      clearConfirmAlertRemind: (state) => {
         state.confirmAlert.remindValue = {};
      }
   },
}
